import $ from "jquery";

const ajax = (thisForm, data) => {
    return new Promise((resolve, reject) =>
        $.ajax({
            type: "POST",
            dataType: "json",
            url: thisForm.attr("action"),
            data: {
                action: thisForm.data("action"),
                nonce: thisForm.data("nonce"),
                ...data,
            },
            success: function (response) {
                resolve(response);
            },
            error: (err) => {
                reject(new Error(err));
            },
        }),
    );
};

export default ajax;
